import React from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import firebase from "firebase/compat/app";
import { VscClose } from "react-icons/vsc";

import { useAppContext } from '../../context/ThemeContext';
import { CommentCard } from './CommentCard';
import { database } from "../../config";

const Comments = ({postid, comments, setShowComment, showComment}) => {
   const { siteTheme, state } = useAppContext();

   let isDay = state.isDay;
	if (JSON.parse(sessionStorage.getItem("isDay"))) {
		isDay = JSON.parse(sessionStorage.getItem("isDay"));
	}

   const ContactSchema = Yup.object().shape({
      comment: Yup.string().min(10, "Too Short!").required("Required"),
   });

   async function handleRequest(value) {
		try {
			await database.collection("post-comments").doc(postid).collection("comments").add({
				comment: value?.comment,
				timestamp: firebase.firestore.FieldValue.serverTimestamp(),
			});
		} catch (error) {
			console.error("Error saving request:", error); // Ensure we stop sending event if there's an error
		}
	}

  return (
   <div className={`${siteTheme.textColor} ${showComment ? "right-0" : "right-[-100%] sm:right-[-50%]" } absolute z-10 w-[80%] sm:w-[50%] xl:w-[35%] pb-16 pt-28 backdrop-blur-lg shadow-lg ${isDay ? "shadow-neutral-400/30" : "shadow-neutral-700/30"} ${siteTheme.background} ease-in duration-500 flex flex-col justify-between h-[100vh] px-4 mx-auto max-w-max-content-width overflow-hidden`}>
      {comments?.length ? 
         <div className={`h-[100%] overflow-auto mb-5`}>
            {comments?.map(comment => (
               <CommentCard isDay={isDay} props={comment} siteTheme={siteTheme} />
            ))}
         </div> 
         : <div className={`text-neutral-600 text-sm tracking-wider flex flex-col items-center justify-center h-[100%] w-[90%] mx-auto text-center`}>
               <p>--No comment yet--</p>
               <p>Be the first to comment on this post</p>
            </div>
      }
      <Formik 
         initialValues={{
            comment: "",
         }}
         validationSchema={ContactSchema}
         onSubmit={async (values, { resetForm }) => {
            handleRequest(values);
            resetForm();
         }}
      >
         {({ errors, touched }) => (
            <Form className="flex flex-col gap-y-2">
               <Field
                  id="comment"
                  name="comment"
                  placeholder="> Enter comment..."
                  type="text"
                  className={`p-1 border-[0.5px] placeholder:text-left placeholder:font-thin focus:ring-0 focus:border-neutral-600 border-neutral-700 rounded-xl bg-[rgba(250,250,250,0.02)] text-sm`}
               />
            </Form>
         )}
      </Formik>
      <div onClick={() => setShowComment(false)} className={`absolute top-20 right-4 cursor-pointer`}>
         <VscClose size={26} />
      </div>
   </div>
  )
}

export { Comments }
export default Comments
